/**
 * Transforms collective data received from the server (decimal format)
 * to the format expected by the form (percentage format)
 * @param {Object} serverData - Data from the server with salesTaxPct as decimal (0-1)
 * @returns {Object} Data formatted for the form with salesTaxPct as percentage (0-100)
 */
import {
  serverToFormPercent,
  formToServerPercent,
} from "../../../common/percentUtils";

export const convertServerToFormValues = (serverData) => {
  const retailMarkupPct = serverToFormPercent(serverData.retailMarkupPct);
  return {
    ...serverData,
    salesTaxPct: serverToFormPercent(serverData.salesTaxPct).toString(),
    retailMarkupPct: retailMarkupPct.toString(),
    enableRetailSales: retailMarkupPct.gt(0),
  };
};

/**
 * Transforms collective data from the form (percentage format)
 * to the format expected by the server (decimal format)
 * @param {Object} formData - Data from the form with salesTaxPct as percentage (0-100)
 * @returns {Object} Data formatted for the server with salesTaxPct as decimal (0-1)
 */
export const convertFormToServerValues = (formData) => {
  const { enableRetailSales, ...dataWithoutEnableFlag } = formData;
  const retailMarkupPct = enableRetailSales
    ? formToServerPercent(formData.retailMarkupPct)
    : 0;
  return {
    ...dataWithoutEnableFlag,
    salesTaxPct: formToServerPercent(formData.salesTaxPct),
    retailMarkupPct: retailMarkupPct.toString(),
  };
};
